import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  /** Кастомный текст вместо дефолтного «Нет данных» */
  children?: ReactNode;
};

/**
 * Плейсхолдер пустого состояния карточки: блок есть, показывать в нём нечего.
 * По умолчанию выводит переведённое «Нет данных».
 */
export const EmptyState: FC<Props> = ({ children }) => {
  const { t } = useTranslation('common');
  return <div className="text-muted-foreground text-sm">{children ?? t('noData')}</div>;
};
